import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import { ADMIN_API_URL, adminRequest, getAdminToken } from './adminApi';

export const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(Boolean(getAdminToken()));

  const logout = useCallback(() => {
    sessionStorage.removeItem('eulua_admin_token');
    setAdmin(null);
  }, []);

  useEffect(() => {
    const restoreSession = async () => {
      if (!getAdminToken()) {
        setLoading(false);
        return;
      }
      try {
        const data = await adminRequest('/admin/me');
        setAdmin(data.admin);
      } catch (error) {
        logout();
      } finally {
        setLoading(false);
      }
    };
    restoreSession();
  }, [logout]);

  useEffect(() => {
    window.addEventListener('eulua-admin-session-expired', logout);
    return () => window.removeEventListener('eulua-admin-session-expired', logout);
  }, [logout]);

  const login = async (email, password) => {
    const response = await fetch(`${ADMIN_API_URL}/admin/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, website: '' }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || 'Unable to sign in');
    sessionStorage.setItem('eulua_admin_token', data.token);
    setAdmin(data.admin);
    return data.admin;
  };

  const value = useMemo(() => ({ admin, loading, login, logout }), [admin, loading, logout]);
  return <AdminAuthContext.Provider value={value}>{children}</AdminAuthContext.Provider>;
};
